import React from 'react';
import { calcExpiresIn, getOrderPopupText, getSingleItem } from '../services/utils';
import { MONTHS } from '../constants/order';

class Context extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            horPos: {},
            vertPos: {}
        }
    }

    componentDidMount() {
        let windowWidth = window.innerWidth,
        windowHeight = window.innerHeight,
        menuWidth = this.contextMenuNode.getBoundingClientRect().width,
        menuHeight = this.contextMenuNode.getBoundingClientRect().height,
        x = this.props.x || 0,
        y = this.props.y || 0,
        horPos = {}, vertPos = {};

        if (x + menuWidth > windowWidth) {
            horPos.right = '0px';
        } else {
            horPos.left = x + 'px';
        }

        if (y + menuHeight > windowHeight) {
            vertPos.bottom = '0px';
        } else {
            vertPos.top = y + 'px';
        }

        this.setState({
            horPos,
            vertPos
        })
    }

    openOrderPopup(viewMode, id = null) {
        let { getOrder, showOrder, params, user, marketLogArgs, duplicateOrder } = this.props,
        includedId = marketLogArgs.include && marketLogArgs.include.products.length == 1 ? marketLogArgs.include.products[0] : '',
        createParams, statusMode;

        if (showOrder && typeof showOrder == 'function') {
            if (viewMode == 'create' || viewMode == 'create-finalised') {
                createParams = params.product_id || includedId ?
                    { product_id: params.product_id || includedId } : {};

                showOrder(viewMode, createParams);
            } if (viewMode == 'duplicate-buy') {
                viewMode = 'duplicate'
                getOrder(
                    id,
                    viewMode: viewMode,
                    duplicateOrder,
                    'BUY'
                );
            } else if (viewMode == 'duplicate-sell') {
                viewMode = 'duplicate'
                getOrder(
                    id,
                    viewMode: viewMode,
                    duplicateOrder,
                    'SELL'
                );
            } else {
                statusMode = (user.isAdmin || user.isSuperUser) ? 'edit' : 'view';

                if (id != null) {
                    getOrder(
                        id,
                        viewMode: statusMode,
                        showOrder
                    );
                }
            }

            this.props.close();
        }
    }

    showSaveView() {
      this.props.showSaveView();
      this.props.close();
    }

    deleteOrder(id) {
        let currentUser = this.props.user.userInfo,
        { products, company_id } = currentUser,
        isSuperUser = this.props.user.isSuperUser || this.props.user.isAdmin;

        const processDelete = params => {           
            let trading_period_interval = params.trading_period_interval || '',
            trading_period_month,
            trading_period_year,
            is_custom_timeframe = !!params.is_custom_timeframe,
            trading_period_custom = is_custom_timeframe ? params.trading_period: '',
            product = getSingleItem(params.product_id, products);

            let newParams = {
                ...params,
                trading_period_interval,               
                trading_period_custom,
                allFreights: this.props.freights
            };

            let popupText = getOrderPopupText(currentUser, product, [], [], 'delete', is_custom_timeframe, newParams);

            this.props.deleteOrder(id, popupText);
            this.props.close();
        };
        const deleteOrder = (mode, params) => {            
            processDelete(params);            
        }

        this.props.getOrder(id, false, deleteOrder);
    }

    removeFromTradingScreen(order_id) {
        this.props.setShowTraded(order_id, 0);
        this.props.close();
    }

    onClose(e) {
        if (e.target.className=='context-menu-overlay')
            this.props.close();
    }

    renderMenu() {
        

        let { params, deleteOrder, user, isOnlineMarketLogVisible, isOnlineMarketLogGridVisible, screenUrl } = this.props
        let isCMEUser = user.userInfo.cme_cleared,
        isCMECleared = (isCMEUser && params.contract_type == 'CME') || params.contract_type != 'CME',
        isSuperUser = user.isSuperUser || user.isAdmin,
        isOwnerBuy = params ? params.creator_company_id_buy == user.userInfo.company_id : null,
        isExpiredBuy = params ? params.status_buy == 'EXPIRED' || !!+params.isExpired_buy : null,
        isClosedBuy = params ? params.status_buy == 'CLOSED' : null,
        isOwnerSell = params ? params.creator_company_id_sell == user.userInfo.company_id : null,
        isExpiredSell = params ? params.status_sell == 'EXPIRED' || !!+params.isExpired_sell : null,
        isClosedSell = params ? params.status_sell == 'CLOSED' : null,
        showSaveCustomOM = screenUrl == '/onlinemarkets' && isOnlineMarketLogVisible && !isOnlineMarketLogGridVisible,
        saveCustomOM = showSaveCustomOM ?
        <div
          onClick={this.showSaveView.bind(this)}
          className='context-menu-action icon-save'>
            Save view
        </div> : null;

        const viewOrEditBuy = () => {
            let key = isClosedBuy ? (isSuperUser ? 'edit-finalised' : 'view') : 'edit';
            const label = key === 'view' ? key : 'edit';
            return <div
                onClick={this.openOrderPopup.bind(this, key, params.order_id_buy)}
                className={'context-menu-action icon-'+label}>
                {label[0].toUpperCase() + label.slice(1) + ' bid'} 
            </div>
        }

        const viewOrEditSell = () => {
            let key = isClosedSell ? (isSuperUser ? 'edit-finalised' : 'view') : 'edit';
            const label = key === 'view' ? key : 'edit';
            return <div
                onClick={this.openOrderPopup.bind(this, key, params.order_id_sell)}
                className={'context-menu-action icon-'+label}>
                {label[0].toUpperCase() + label.slice(1) + ' offer'} 
            </div>
        }


        const duplicateBuy = !isCMECleared ? ()=>{} : () => {
            let key = 'duplicate-buy';
            const label = 'Create';
            return <div
                onClick={this.openOrderPopup.bind(this, key, (params.order_id_buy ? params.order_id_buy : params.order_id_sell))}
                className={'context-menu-action icon-add'}>
                {label[0].toUpperCase() + label.slice(1) + ' bid'} 
            </div>
        }

        const duplicateSell = !isCMECleared ? ()=>{} : () => {
            let key =  'duplicate-sell';
            const label = 'Create';
            return <div
                onClick={this.openOrderPopup.bind(this, key, (params.order_id_sell ? params.order_id_sell : params.order_id_buy))}
                className={'context-menu-action icon-add'}>
                {label[0].toUpperCase() + label.slice(1) + ' offer'} 
            </div>
        }


        if (params && params.extended) {
            return (
                <div>
                    { !params.order_id_buy && !params.order_id_sell ?
                    <div
                        onClick={this.openOrderPopup.bind(this, 'create', null)}
                        className='context-menu-action icon-add'>
                        Create new order
                    </div> : null }
                    { isSuperUser ?
                        <div>
                            <div
                                onClick={this.openOrderPopup.bind(this, 'create-finalised',  (params.order_id_sell ? params.order_id_sell : params.order_id_buy))}
                                className='context-menu-action icon-add'>
                                Create finalised order
                            </div>
                        </div>
                    : null }


                    { params.order_id_buy  || params.order_id_sell
                        ? duplicateBuy()
                        : null }

                    { params.order_id_sell || params.order_id_buy 
                        ? duplicateSell()
                        : null }

                    { params.order_id_buy && (isSuperUser || isOwnerBuy || isClosedBuy)
                        ? viewOrEditBuy()
                        : null
                    }
                    { params.order_id_sell && (isSuperUser || isOwnerSell || isClosedSell)
                        ? viewOrEditSell()
                        : null
                    }

                    { params.order_id_buy && (isSuperUser || isOwnerBuy) && !isClosedBuy ?
                        <div
                            onClick={this.deleteOrder.bind(this, params.order_id_buy)}
                            className='context-menu-action icon-delete'>
                            Delete bid
                        </div>
                    : null }
                    { params.order_id_sell && (isSuperUser || isOwnerSell) && !isClosedSell ?
                        <div
                            onClick={this.deleteOrder.bind(this, params.order_id_sell)}
                            className='context-menu-action icon-delete'>
                            Delete offer
                        </div>
                    : null }

                    { params.order_id_buy && isSuperUser && isClosedBuy ?
                        <div
                            onClick={this.removeFromTradingScreen.bind(this, params.order_id_buy)}
                            className='context-menu-action icon-delete'>
                            Remove from trading screen
                        </div>
                    : null }
                    { params.order_id_sell && isSuperUser && isClosedSell ?
                        <div
                            onClick={this.removeFromTradingScreen.bind(this, params.order_id_sell)}
                            className='context-menu-action icon-delete'>
                            Remove from trading screen
                        </div>
                    : null }

                    { saveCustomOM }
                </div>
            )
        } else {
            return (
                <div>
                    <div
                        onClick={this.openOrderPopup.bind(this, 'create', null)} // null is required, otherwise event will be passed as id
                        className='context-menu-action icon-add'>
                        Create new order
                    </div>
                    { isSuperUser ?
                    <div
                        onClick={this.openOrderPopup.bind(this, 'create-finalised', null)}
                        className='context-menu-action icon-add'>
                        Create finalised order
                    </div> : null }
                    { saveCustomOM }
                </div>

            );
        }
    }

	render() {
        let { horPos, vertPos } = this.state;

        return (
            <div className='context-menu-overlay'
                name='context-menu-overlay'
                onClick={this.onClose.bind(this)}>
                <div
                    style={{...horPos, ...vertPos}}
                    ref={node => this.contextMenuNode = node}
                    className='context-menu'>

                    { this.renderMenu() }

                </div>
            </div>
        )
    }
}

export default Context;



// WEBPACK FOOTER //
// ./source/components/contextMenu.js